import {combineReducers} from 'redux';

import {entity as bulkFilePages} from './bulkFilePages';
import {entity as bulkFileWorkflows} from './bulkFileWorkflows';
import {entity as schoolYears} from './schoolYears';
import {entity as checklistItems} from './checklistItems';

import {push} from 'react-router-redux';

import {actionize} from 'utils';

let types = {
  LOAD_BULK_FILE_WORKFLOWS: null,
  SHOW_CREATE_MODAL: null,
  HIDE_CREATE_MODAL: null,

  SET_PROPS: null,

  GET_BULK_FILE_PAGE: null,
  COMMIT_BULK_FILE_WORKFLOW: null
};
types = actionize(types, (action) => `schooladmin/bulkFileUploader/${action}`);

// reducers
// create modal
const initialCreateModalState = {
  showCreateModal: false,
  schoolYearId: null,
  checklistItemId: null,
  file: null,

  submitting: false,

  createErrors: null
};
const createModal = (state=initialCreateModalState, action) => {
  switch(action.type){
    case types.SHOW_CREATE_MODAL:
      return {...initialCreateModalState, showCreateModal: true};
    case types.HIDE_CREATE_MODAL:
      return {...initialCreateModalState, showCreateModal: false};

    case bulkFileWorkflows.actions.SAVE_ERROR:
      return {...state, createErrors: action.errors || {error: ["Unknown Error"]}, submitting: false};
    case bulkFileWorkflows.actions.SAVE_SUCCESS:
      return {...state, createErrors: null, showCreateModal: false, submitting: false};

    case types.SET_PROPS:
      const {props} = action;
      return {...state, ...props};

    case bulkFileWorkflows.actions.SAVE_BEGIN:
      return {...state, submitting: true};
  }

  return initialCreateModalState;
};

// errors
const initialErrorState = {
  commitErrors: null,
  pageErrors: null
};

const errors = (state=initialErrorState, action) => {
  switch(action.type) {
    case bulkFileWorkflows.actions.COMMIT_ERROR:
      return {...state, commitErrors: action.errors || {error: ["Unknown Error"]}};
    case bulkFileWorkflows.actions.COMMIT_SUCCESS:
      return {...state, commitErrors: null};

    case bulkFileWorkflows.actions.GET_ERROR:
    case bulkFilePages.actions.GET_ERROR:
    case bulkFilePages.actions.SAVE_ERROR:
      return {...state, pageErrors: action.errors || {error: ["Unknown Error"]}};
    case bulkFilePages.actions.SAVE_SUCCESS:
      return {...state, pageErrors: null};

    case bulkFileWorkflows.actions.GET_SUCCESS:
      return initialErrorState;
  }

  return state;
};

// actions
const showCreateModal = () => (dispatch) => {
  dispatch({
    type: types.SHOW_CREATE_MODAL
  });
};

const hideCreateModal = () => ({
  type: types.HIDE_CREATE_MODAL
});

const setCreateModalProps = (props) => ({
  type: types.SET_PROPS,
  props
});

const createWorkflow = (workflow) => (dispatch) => {
  return dispatch(bulkFileWorkflows.actions.create(workflow))
    .then((payload) => {
      dispatch(bulkFileWorkflows.actions.markDirty());

      return dispatch(push(`/setup/bulk_file_workflows/${payload.result.bulk_file_workflow}`));
    });
};

export const actions = {
  showCreateModal,
  hideCreateModal,
  setCreateModalProps,
  createWorkflow
};

const reducer = combineReducers({
  createModal,
  errors
});

export default reducer;
